import React from 'react'
import { Image, StyleSheet } from 'react-native'

export default function Logo() {
  return <Image source={require('../assets/imgs/logo/dashboard-logo.png')} style={styles.image} />
}

const styles = StyleSheet.create({
  image: {
    width: 140,
    height: 90,
    marginBottom: 8,
    alignSelf: 'center',
  },
})
